module.exports = __webpack_public_path__ + "assets/img/1-402f7fcf.jpg";